exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.v-input__control .v-text-field__suffix {\n    color: rgba(0, 0, 0, 0.58)\n}\n", ""]);
